import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import IconButton from '../../components/buttons/IconButton';

const ConfirmModal = ({
  onConfirm,
  subtitle = '',
  showPrompt,
  setShowPrompt,
  title,
  description,
  cancelText,
  confirmText,
  blockCloseIfFalse = false,
  bottomContent,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setShowPrompt(true);
    setLoading(true);
    const res = await onConfirm();
    setLoading(false);
    if (res === false && blockCloseIfFalse) {
      return;
    }
    setShowPrompt(false);
  };
  return (
    <Transition appear show={showPrompt} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-40 align-middle"
        static
        open={showPrompt}
        onClose={() => setShowPrompt(false)}
      >
        <div className="fixed min-h-screen w-screen text-center flex items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300 opacity-30"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-[#031211] transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="flex flex-col items-center mx-auto  w-[350px] sm:w-[500px] max-h-[90vh] overflow-y-auto my-10 overflow-hidden text-left align-middle transition-all transform bg-white  rounded-md z-30">
              <div className="flex flex-col items-center justify-start w-full">
                <div className="text-left pb-4 px-6 pt-6 border-b border-neutral-50 w-full">
                  <Dialog.Title
                    as="h3"
                    className="text-4xl w-full  font-semibold text-left text-neutral-900 bg-6"
                  >
                    {title}
                  </Dialog.Title>
                  <Dialog.Description
                    as="p"
                    className="text-base font-normal text-neutral-700"
                  >
                    {subtitle}
                  </Dialog.Description>
                </div>
                <Dialog.Panel
                  as="div"
                  className="text-md text-center text-neutral-900 mt-2 w-full px-6 pb-6 pt-4"
                >
                  {description}
                </Dialog.Panel>
              </div>

              <div className="flex justify-between p-6 border-t border-neutral-50 items-center w-full">
                <IconButton
                  type="button"
                  classes="max-w-[6rem]"
                  text={cancelText || 'Cancel'}
                  style="outline"
                  handleClick={() => setShowPrompt(false)}
                />
                <IconButton
                  text={confirmText || 'Confirm'}
                  classes="max-w-[6rem]"
                  disabled={loading}
                  type="button"
                  style="primary"
                  handleClick={handleClick}
                />
              </div>
              {bottomContent && (
                <div className="mt-4 w-full">{bottomContent}</div>
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmModal;
